module.exports = __webpack_public_path__ + "img/c04_unittechpalintononchampion_Normal_ua.3a7e1799.webp";